export const LOAD_IMAGE_EDITORS_SUCCESS = 'LOAD_IMAGE_EDITORS_SUCCESS';
export const ADD_IMAGE_EDITOR_USER_SUCCESS = 'ADD_IMAGE_EDITOR_USER_SUCCESS';
export const DELETE_IMAGE_EDITOR_USER_SUCCESS = 'DELETE_IMAGE_EDITOR_USER_SUCCESS';
export const UPDATE_IMAGE_EDITOR_USER_SUCCESS = 'UPDATE_IMAGE_EDITOR_USER_SUCCESS';
export const GET_EDIT_IMAGE_EDITOR_SUCCESS = 'GET_EDIT_IMAGE_EDITOR_SUCCESS';
export const GET_NEW_IMAGE_EDITOR_SUCCESS = 'GET_NEW_IMAGE_EDITOR_SUCCESS';
